export default {
  title: {
    preference: 'My Preference',
    surveyQuestion: 'Survey Question',
    survey: {
      candidate: 'Candidate Survey',
      employee: 'Employee Survey'
    },
    lastStep: 'Thanks!'
  },
  label: {
    notification: 'Job Alert Notification Preferences',
    frequency: 'Job Alert Sending Frequency',
    followUs: 'Now for the last step, please follow us on WeChat so you can be the first to know about exciting opportunities tailored just for you.',
    getNews: 'autimated job alerts and career news!',
    submitResume: 'Upload/Edit Resume',
    jobAlertTip: 'Join Our Talent Community!',
    jobAlertContent: [
      'Join our Talent Community and get personalized job alerts based on your skills and interests.\n',
      "You'll also stay connected with our latest career opportunities, news, and events.\n",
      'It takes just two minutes to:'
    ].join('\n'),
    jobAlertContentFooter: "When a role, event, or update matches your profile, we'll let you know — so you never miss an opportunity that's right for you.",
    jobAlertLoginList: [
      'Share a few details about your interests',
      'Upload or create your resume'
    ],
    jobAlertNoLoginList: [
      'Register',
      'Share a few details about your interests',
      'Upload or create your resume'
    ],
    viewMyPreferredJobs: 'View My Preferred Jobs'
  },
  message: {
    saveSuccess: 'Save Success!',
    noAnswerQuestion: 'This field cannot be empty'
  },
  menu: {
    home: 'Home'
  },
  btn: {
    goQuestion: {
      new: 'Let\'s Go',
      modify: 'Modify'
    },
    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    save: 'Save',
    continue: 'Next'
  },
  notificationType: {
    wechat: 'WeChat',
    email: 'Email',
    both: 'WeChat & Email'
  },
  frequency: {
    weekly: 'Weekly',
    monthly: 'Monthly',
    off: 'Off'
  },
  questionType: {
    dropdown: 'Single Choice',
    checkbox: 'Multiple Choice'
  },
  step: {
    register: 'Register',
    survey: 'Preference Survey',
    submitResume: 'Upload/Edit Resume'
  }
}
